import React, { useState } from 'react'
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux'
import { changePassword } from '../../../../services/operations/settingsAPI';
import { useNavigate } from 'react-router-dom';
import IconBtn from '../../../common/IconBtn';
import { AiOutlineEye, AiOutlineEyeInvisible } from 'react-icons/ai';





const UpdatePassword = () => {

    const {token} = useSelector((state)=>state.auth);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [showOldPassword, setShowOldPassword] = useState();
    const [showNewPassword, setShowNewPassword] = useState();

    const {
        register,
        handleSubmit,
        formState: {errors}
    } = useForm()


    const submitPasswordForm = async(data)=>{
        try{
            dispatch(changePassword(token, data));
        }
        catch(err){
            console.log("ERROR MESSAGE...", err);
        }
    }



  return (
    <form onSubmit={handleSubmit(submitPasswordForm)}>
        <div className='my-10 flex flex-col gap-y-7 rounded-md border-[1px] border-richblack-700 bg-richblack-800 p-8 px-12 text-richblack-5 '>
            <h2 className='text-[18px] font-semibold'>
                Password
            </h2>

            <div className='flex flex-col gap-5 lg:flex-row'>
                {/* current Password */}
                <div className='relative flex flex-col gap-2 lg:w-[48%]'>
                    <label htmlFor='oldPassword' className='label-style'>
                        Current Password
                    </label>
                    <input
                        type={showOldPassword ? "text" : "password"}
                        name='oldPassword'
                        id='oldPassword'
                        placeholder='Enter current Password'
                        className='form-style'
                        {...register("oldPassword", {required: true})}
                    />
                    <span onClick={()=> setShowOldPassword((prev) => !prev )}
                        className='absolute right-3 top-[38px] z-[10] cursor-pointer'
                    >
                        {
                            showOldPassword ? 
                            <AiOutlineEyeInvisible fontSize={24} fill="#AFB2BF"/> : 
                            <AiOutlineEye fontSize={24} fill="#AFB2BF"/>
                        }
                    </span>
                    {
                        errors.oldPassword && (
                            <span className='mt-1 text-[12px] text-yellow-100'>
                                Please enter your current password
                            </span>
                        )
                    }
                </div>

                
                {/* New Password */}
                <div className='relative flex flex-col gap-2 lg:w-[48%]'>
                    <label htmlFor='newPassword' className='label-style'>
                        New Password
                    </label>
                    <input
                        type={showNewPassword ? "text" : "password"}
                        name='newPassword'
                        id='newPassword'
                        placeholder='Enter New Password'
                        className='form-style'
                        {...register("newPassword", {required: true})}
                    />
                    <span onClick={()=> setShowNewPassword((prev) => !prev )}
                        className='absolute right-3 top-[38px] z-[10] cursor-pointer'
                    >
                        {
                            showNewPassword ? 
                            <AiOutlineEyeInvisible fontSize={24} fill="#AFB2BF"/> : 
                            <AiOutlineEye fontSize={24} fill="#AFB2BF"/>
                        }
                    </span>
                    {
                        errors.newPassword && (
                            <span className='mt-1 text-[12px] text-yellow-100'>
                                Please enter your New password
                            </span>
                        )
                    }
                </div>
            </div>

        </div>



        {/* Cancel and Save button */}
        <div className='flex justify-end gap-2'>
            <button 
                onClick={()=>{
                    navigate("/dashboard/my-profile")
                }}
                className='cursor-pointer rounded-md bg-richblack-700 py-2 px-5 font-semibold text-richblack-50'
            >
                Cancel
            </button>
            <IconBtn type="submit" text="Update"/>
        </div>

    </form>
  )
}

export default UpdatePassword